<template>
  <div class="popular">
    <div class="container">
      <div class="popular__wrapper">
        <div class="popular__title">
          <h2>{{ t('home.popular.title') }}</h2>
        </div>
        <swiper
            class="popular__swiper"
            :modules="[Pagination]"
            :pagination="{
                clickable: true
              }"
            :loop="true"
            :speed="500"
            :breakpoints="{
                200: {
                  slidesPerView: 1,
                },
                800: {
                  slidesPerView: 2,
                },
                1250: {
                  slidesPerView: 3,
                }
              }"
        >
          <swiper-slide
              class="popular__swiper-slide"
              v-for="product in products"
              :key="product.node.uuid"
          >
            <product-card
                :product="product.node"
            />
          </swiper-slide>
        </swiper>
      </div>
    </div>
  </div>
</template>

<script setup>
import { Swiper, SwiperSlide } from 'swiper/vue';
import 'swiper/css/pagination';
import 'swiper/css';
import {Pagination} from "swiper/modules";
import {useI18n} from "vue-i18n";
import ProductCard from "@/components/cards/product-card.vue";
import {onMounted, ref, watch} from "vue";
import {Products} from "@/core/api/products.js";

const {t, locale} = useI18n()

const products = ref([])

const getProducts = async () => {
  const res = await Products.getProducts(`tags: "top"`)
  products.value = res.data.products.edges.slice(0, 6)
}

watch(
    () => locale.value,
    async () => {
      products.value = [];
      await getProducts()
    }
)

onMounted( async () => {
  await getProducts()
})
</script>

<style lang="scss" scoped>
.popular {
  position: relative;
  z-index: 1;
  background-image: url(@images/popularBg.png);
  background-repeat: no-repeat;
  background-size: cover;
  padding-block: 100px;

  &__wrapper {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 50px;
  }

  &__title {
    border-radius: 17px;
    background-color: $white;
    box-shadow: 0 4px 13.5px 0 rgba(0, 0, 0, 0.15);
    width: fit-content;
    padding: 5px 30px;

    & h2 {
      font-family: Syne, sans-serif;
      font-size: 50px;
      font-weight: 700;
      background: linear-gradient(90deg, #FF85FD 0.5%, #7D045A 44.83%, #3D2B44 100%);
      background-clip: text;
      -webkit-background-clip: text;
      -webkit-text-fill-color: transparent;
    }
  }

  &__swiper {
    width: 100%;
    padding-bottom: 50px;

    &-slide {
      display: grid;
      place-items: center;
    }
  }
}

@media (max-width: 1000px) {
  .popular {
    &__top {
      &-title {
        padding-bottom: 200px;
      }
    }
  }
}

@media (max-width: 750px) {
  .popular {
    &__top {
      &-title {
        margin-left: 20px;
      }

      &-image {
        right: -200px;
      }
    }
  }
}
</style>